module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_2.c7cad8fc.png";